import * as contracts from './contracts';
import * as remote from './remotes';
import * as stub from './stubs';
import { endpoints } from './endpoints';

type Sources = {
  authorizeSession: contracts.AuthorizeSession;
  getManifest: contracts.GetManifest;
  getAdyenSession: contracts.GetAdyenSession;
  processPayment: contracts.ProcessPayment;
  authorizeApplePay: contracts.AuthorizeApplePay;
  getTransactionStatus: contracts.GetTransactionStatus;
  getCardTokenStatus: contracts.GetCardTokenStatus;
  getPaymentMethods: contracts.GetPaymentMethods;
  payWithStoredPayment: contracts.PayWithStoredPayment;
  getPBLData: contracts.GetPBLData;
  confirmation: contracts.Confirmation;
  sendConfirmationEmail: contracts.SendConfirmationEmail;
  submitAdyenToken: contracts.SubmitAdyenToken;
};

const stubs: Sources = {
  authorizeSession: remote.AuthorizeSessionApi(endpoints.authorizeSessionUrl),
  getManifest: stub.GetManifestStub,
  getAdyenSession: stub.GetAdyenSessionStub,
  processPayment: stub.ProcessPaymentStub,
  authorizeApplePay: stub.AuthorizeApplePayStub,
  getTransactionStatus: stub.GetTransactionStatusStub,
  getCardTokenStatus: stub.GetCardTokenStatusStub,
  getPaymentMethods: stub.GetPaymentMethodsStub,
  payWithStoredPayment: stub.PayWithStoredPaymentStub,
  getPBLData: stub.GetPBLDataStub,
  confirmation: stub.ConfirmationStub,
  sendConfirmationEmail: stub.SendConfirmationEmailStub,
  submitAdyenToken: stub.SubmitAdyenTokenStub,
};

const remotes: Sources = {
  authorizeSession: remote.AuthorizeSessionApi(endpoints.authorizeSessionUrl),
  getManifest: remote.GetManifestApi(endpoints.getManifestUrl),
  getAdyenSession: remote.GetAdyenSessionApi(endpoints.getAdyenSessionUrl),
  processPayment: remote.ProcessPaymentApi(endpoints.processPaymentUrl),
  authorizeApplePay: remote.AuthorizeApplePayApi(endpoints.authorizeApplePayUrl),
  getTransactionStatus: remote.GetTransactionStatusApi(endpoints.getTransactionStatusUrl),
  getCardTokenStatus: remote.GetCardTokenStatusApi(endpoints.getCardTokenStatusUrl),
  getPaymentMethods: remote.GetPaymentMethodsApi(endpoints.getPaymentMethods),
  payWithStoredPayment: remote.PayWithStoredPaymentApi(endpoints.payWithStoredPayment),
  getPBLData: remote.GetPBLDataApi(endpoints.getPBLDataUrl),
  confirmation: remote.ConfirmationApi(endpoints.confirmation),
  sendConfirmationEmail: remote.SendConfirmationEmailApi(endpoints.sendConfirmationEmail),
  submitAdyenToken: remote.SubmitAdyenTokenApi(endpoints.submitAdyenTokenUrl),
};

export const sources = import.meta.env.VITE_ENV === 'local' ? stubs : remotes;
